import * as React from 'react';
import * as PropTypes from 'prop-types';
import withMParticleListings from '@reverbdotcom/commons/dist/components/with_mparticle_listings';
import { trackInteraction } from '@reverbdotcom/commons/dist/tracker';
import { APIRequest, Modal, UserStore, HashUtil } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../../shared/url_helpers';
import CartActions from '../../cart/cart_actions';
import SuccessModalContainer from './success_modal_container';

import {
  MParticleEventName,
} from '@reverbdotcom/commons/dist/elog/mparticle_types';

// Like AjaxAddToCartButton but adds multiple products to your cart.
export class AjaxMultiAddToCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdding: false,
      isModalOpen: false,
      successMessage: null,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount() {
    this.$quantitySelector = $('.jq-checkout-quantity');
  }

  quantity() {
    if (this.$quantitySelector.length === 0) { return null; }
    return this.$quantitySelector.val();
  }

  showSellerBlock() {
    Reverb.BlockSellerAction.showMessage(I18n.t('js.addToCart.sellerBlockMessage'));
  }

  handleClick() {
    if (this.props.isOwner) {
      this.showSellerBlock();
      return;
    }

    this.setState({ isAdding: true });

    APIRequest.V3.post(
      UrlHelpers.addMultipleToCartPath,
      JSON.stringify(this.params()),
      {
        contentType: 'application/json',
      },
    )
      .then(this.handleSuccess)
      .fail(this.handleError);

    trackInteraction({
      componentName: this.props.trackName,
      mParticleData: {
        quantity: (this.quantity() || 1),
        eventName: MParticleEventName.AddToCart,
        listing: this.props.mParticleListings[0],
      },
    });
  }

  updateFacebook() {
    const metaData = ({ content_type: 'Product', content_ids: this.props.listingIds });
    if (window.fbq) {
      window.fbq('track', 'AddToCart', metaData);
    }
  }

  handleSuccess(response) {
    this.updateFacebook();

    if (UserStore.isExperimentEnabled('bypass_upsell_modal')) {
      window.location = '/cart';
    } else {
      CartActions.loadCart();
      this.setState({
        isAdding: false,
        successMessage: response.message,
        isModalOpen: true,
      });
    }
  }

  handleError(response) {
    this.setState({
      isAdding: false,
    });
    this.props.onError(response.responseJSON.message);
  }

  handleCloseModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  params() {
    return {
      products: this.productParams(),
      _aid: this.props.aid,
      source: this.props.source,
      action_source_attributes: {
        device: UserStore.getState().deviceType,
      },
    };
  }

  productParams() {
    return this.props.listingIds.map(productId => HashUtil.rejectBlankValues({
      id: productId,
      quantity: this.quantity(),
    }));
  }

  renderButtonText() {
    if (this.state.isAdding) {
      return I18n.t('js.addToCart.button.adding');
    } else if (this.props.onPreorder) {
      return I18n.t('js.addToCart.button.preorder');
    }

    return this.props.text || I18n.t('js.addToCart.button.add');
  }

  renderSuccessModal() {
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        onRequestClose={this.handleCloseModal}
        subClass="cart-upsell"
        newClose
      >
        <SuccessModalContainer
          productIds={this.props.listingIds}
          message={this.state.successMessage}
          zeroPercentAffirmFinancing={this.props.zeroPercentAffirmFinancing}
        />
      </Modal>
    );
  }

  render() {
    const buttonText = this.renderButtonText();

    return (
      <div>
        <button
          onClick={this.handleClick}
          className="add-to-cart-button"
          aria-label={buttonText}
          disabled={this.state.isAdding || null}
        >
          {buttonText}
        </button>
        {this.renderSuccessModal()}
      </div>
    );
  }
}

AjaxMultiAddToCartButton.propTypes = {
  aid: PropTypes.string,
  isOwner: PropTypes.bool,
  mParticleListings: PropTypes.arrayOf(PropTypes.any),
  listingIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onError: PropTypes.func,
  onPreorder: PropTypes.bool,
  source: PropTypes.string,
  text: PropTypes.string,
  trackName: PropTypes.string,
  zeroPercentAffirmFinancing: PropTypes.bool,
};

AjaxMultiAddToCartButton.defaultProps = {
  aid: '',
  isOwner: false,
  onError: () => {},
  onPreorder: false,
  mParticleListings: [],
  source: '',
  text: '',
  trackName: 'add_to_cart',
  zeroPercentAffirmFinancing: false,
};

export default withMParticleListings(false)(AjaxMultiAddToCartButton);



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/ajax_multi_add_to_cart_button.jsx